import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function LatestUpdates() {
  const latestComics = [...comics].sort((a, b) => b.updateTime.localeCompare(a.updateTime)).slice(0, 8);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-14">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
            最新更新
          </h2>
          <p className="text-sm text-foreground-500 mt-1">每日为您带来最新韩国漫画资源</p>
        </div>
        <Link
          to="/category/new"
          className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
        {latestComics.map((comic) => (
          <ComicCard
            key={comic.id}
            id={comic.id}
            title={comic.title}
            author={comic.author}
            cover={comic.cover}
            status={comic.status}
            rating={comic.rating}
            views={comic.views}
            updateTime={comic.updateTime}
          />
        ))}
      </div>
    </section>
  );
}